// What the site collects, why, and how to have it removed.
import { PRIVACY_EMAIL } from "../content/contact";
import { useTitle } from "../ui/hooks";
import { PageHero } from "../ui/Section";

const SECTIONS = [
  ["What we collect", "When you sign the Charter: your name, email address, organisation (if you give one), what you asked to hear about, whether you want updates or to be listed publicly, and when you signed. Nothing else is collected by the site's pages: no analytics, no advertising, no tracking cookies."],
  ["Why", "To count signatures, to keep one signature per person, and, only if you asked, to email you about the Charter, the community or early access. We never show your email address, and we never sell or share it."],
  ["Being listed", "Signatures are shown only as a count. If you ticked the box, your name and organisation may appear in a public list of signatories when that list opens; we will not publish your email."],
  ["Server logs", "Like any web server, ours records requests, including IP addresses, to keep the site secure and working. The logs are rotated and are not used to profile anyone. The signature form uses your address in memory to slow down abuse; it is not stored with your signature."],
  ["In your browser", "The site remembers your light or dark theme in your browser's local storage. That never leaves your device."],
  ["The free tools", "The Meter, the guard calculator and the validator run entirely in your browser. What you type or open there is not sent to us."],
] as const;

export function Privacy() {
  useTitle("Privacy");
  return (
    <>
      <PageHero kicker="§ Privacy" title={<>What we keep, and why.</>}>
        We ask AI companies to be private by default. This site holds itself to the same standard.
      </PageHero>
      <section className="wrap max-w-4xl py-12">
        <dl className="space-y-8">
          {SECTIONS.map(([t, d]) => (
            <div key={t}>
              <dt className="font-display text-2xl font-bold tracking-tight">{t}</dt>
              <dd className="mt-2 font-serif text-[1.15rem] leading-relaxed text-ink2">{d}</dd>
            </div>
          ))}
          <div>
            <dt className="font-display text-2xl font-bold tracking-tight">Removing your signature</dt>
            <dd className="mt-2 font-serif text-[1.15rem] leading-relaxed text-ink2">
              Email{" "}
              <a href={`mailto:${PRIVACY_EMAIL}`} className="link">
                {PRIVACY_EMAIL}
              </a>{" "}
              from the address you signed with, and we will delete your signature and everything stored with it.
            </dd>
          </div>
        </dl>
      </section>
    </>
  );
}
